import { render, staticRenderFns } from "./RecipientRiskEmailInput.vue?vue&type=template&id=0948b811&scoped=true"
import script from "./RecipientRiskEmailInput.vue?vue&type=script&lang=js"
export * from "./RecipientRiskEmailInput.vue?vue&type=script&lang=js"
import style0 from "./RecipientRiskEmailInput.vue?vue&type=style&index=0&id=0948b811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0948b811",
  null
  
)

export default component.exports